import React, { useEffect, useState } from 'react';
import styles from './styles.scss';
import { Button, InputBox, Icons } from '@densityco/ui';
import { ON_PREM_CORE_API_BASE_URL } from '../../utils/environment';
import useRxStore from '../../utils/use-rx-store';
import SessionStore from '../../rx-stores/session';
import useRxDispatch from '../../utils/use-rx-dispatch';
import { rxDispatch } from '../../rx-stores';
import { SessionActionTypes } from '../../types/session';

import FormLabel from '../FormLabel';
import { Toaster } from '@densityco/ui';

export const LoginCore: React.FunctionComponent<{
  location: { pathname: string; search: string };
}> = ({ location }) => {
  const [password, setPassword] = useState('');
  const [email, setEmail] = useState('');

  function login() {
    const request = fetch(`${ON_PREM_CORE_API_BASE_URL}/v2/login`, {
      method: 'POST',
      body: JSON.stringify({
        email: email,
        password: password,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    });

    request.catch(err => {
      Toaster.showToast({text: 'Error logging in!', type: 'error'});
    });

    request.then(async response => {
      if (!response.ok) {
        Toaster.showToast({text: 'Error logging in!', type: 'error'});
        return;
      }

      const data = await response.json();
      rxDispatch({
        type: SessionActionTypes.SESSION_SET_TOKEN,
        token: data,
      });

      const next = window.localStorage.loginNext || '/';
      window.location.hash = `#${next}`;
    });
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.inner} data-test-id="login-core-form">
        <div className={styles.logo}>
          <Icons.DensityMark width={24} height={24} />
          <span className={styles.text}>Sensei</span>
        </div>

        <div className={styles.body}>
          <FormLabel
            label="Your Email"
            htmlFor="email"
            input={
              <InputBox
                id="email"
                type="text"
                data-test-id="username-field"
                value={email}
                width="100%"
                placeholder="ex: bonnie.raitt@density.io"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setEmail(e.target.value)
                }
              />
            }
          />

          <FormLabel
            label="Your Password"
            htmlFor="password"
            input={
              <InputBox
                id="password"
                type="password"
                data-test-id="password-field"
                width="100%"
                placeholder="Password"
                value={password}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setPassword(e.target.value)
                }
                onKeyPress={e => {
                  if (e.key === 'Enter') {
                    login();
                  }
                }}
              />
            }
          />
        </div>

        <Button
          variant="filled"
          width="100%"
          data-test-id="submit"
          onClick={() => login()}
        >
          Log in to Sensei
        </Button>
      </div>
    </div>
  );
};
